import { handleError, handleResponse, MyAxiosSilent } from '@services/SettingAxios';

export interface ECommerceProductInfo2 {
  item_name: string;
  price: number;
  item_id: number;
  item_rn: string;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_category3: string;
  item_category4: string;
  item_variant: string;
  quantity: number;
}

export interface ECommerceProductInfo {
  id: number;
  part: number;
  category: string;
  product: {
    name: string;
    mnfCode: string;
    price: number;
    rn: number;
    brand: {
      id: number;
      fullName: string;
    };
    model: {
      id: number;
      fullName: string;
      type: number;
    };
    width: number;
    height: number;
    season: number;
    radius: number;
    pcde: number;
    pcdd: number;
    et: number;
    dia: number;
  };
}

class ServiceProduct {
  async getProductsFromTuples(tuples: string[], isNew = false): Promise<ECommerceProductInfo[] | ECommerceProductInfo2[]> {
    return MyAxiosSilent.post('/api/catalog/get-product-tuples', {
      tuples,
      isNew,
    })
      .then(handleResponse)
      .catch(handleError);
  }
}

const serviceProductInstance = new ServiceProduct();

export default serviceProductInstance;
